export default {
  provider: {
    categoryDesc: {
      ai_model:
        'Configure and manage external AI models, including LLM, embedding, and vision models.',
      database:
        'Configure and manage external databases, including MySQL, Redis, and Milvus.',
      storage:
        'Configure and manage cloud storage services, including OSS, S3, and COS.',
      message:
        'Configure and manage message channels, including email, DingTalk, and Slack.',
      web_search:
        'Configure and manage web search services, including Google, Bing, and SearXNG.',
      other: 'Configure and manage other external services.',
    },
    // AI Model Providers
    openai: {
      name: 'OpenAI',
      description:
        'OpenAI API, supports GPT-4, GPT-3.5, Whisper, DALL-E, and more',
    },
    azure_openai: {
      name: 'Azure OpenAI',
      description: 'Microsoft Azure OpenAI Service',
    },
    anthropic: {
      name: 'Claude',
      description: 'Anthropic Claude series models',
    },
    qwen: {
      name: 'Qwen',
      description: 'Alibaba Cloud Tongyi Qianwen LLM and AI services',
    },
    moonshot: {
      name: 'Moonshot Kimi',
      description: 'Moonshot AI Kimi large language model',
    },
    google_gemini: {
      name: 'Google Gemini',
      description: 'Google Gemini multimodal models',
    },
    ollama: {
      name: 'Ollama',
      description: 'Locally deployed open-source models (Llama, Mistral, etc.)',
    },
    volcengine: {
      name: 'Volcengine',
      description:
        'Volcengine AI services (Doubao LLM, TTS, STT, Image Generation, etc.)',
    },
    minimax: {
      name: 'MiniMax',
      description: 'MiniMax AI services',
    },
    // Database Providers
    mysql: {
      name: 'MySQL',
      description: 'MySQL relational database',
    },
    postgresql: {
      name: 'PostgreSQL',
      description: 'PostgreSQL database with pgvector extension support',
    },
    redis: {
      name: 'Redis',
      description: 'Redis in-memory data store',
    },
    milvus: {
      name: 'Milvus',
      description: 'Milvus vector database',
    },
    elasticsearch: {
      name: 'ElasticSearch',
      description: 'ElasticSearch search engine',
    },
    sqlite: {
      name: 'SQLite',
      description: 'SQLite lightweight embedded database',
    },
    bytehouse: {
      name: 'ByteHouse',
      description: 'Volcengine ByteHouse cloud-native data warehouse',
    },
    // Storage Providers
    aliyun_oss: {
      name: 'Alibaba Cloud OSS',
      description: 'Alibaba Cloud Object Storage Service',
    },
    aws_s3: {
      name: 'AWS S3',
      description: 'Amazon S3 object storage',
    },
    tencent_cos: {
      name: 'Tencent Cloud COS',
      description: 'Tencent Cloud Object Storage',
    },
    minio: {
      name: 'MinIO',
      description: 'MinIO S3-compatible object storage',
    },
    google_drive: {
      name: 'Google Drive',
      description: 'Google Drive cloud storage',
    },
    onedrive: {
      name: 'OneDrive',
      description: 'Microsoft OneDrive cloud storage',
    },
    dropbox: {
      name: 'Dropbox',
      description: 'Dropbox cloud storage',
    },
    aliyun_drive: {
      name: 'Aliyun Drive',
      description: 'Alibaba Cloud Drive personal cloud storage',
    },
    baidu_pan: {
      name: 'Baidu Netdisk',
      description: 'Baidu Netdisk cloud storage',
    },
    webdav: {
      name: 'WebDAV',
      description: 'WebDAV protocol storage service',
    },
    // Message Providers
    email_smtp: {
      name: 'Email (SMTP)',
      description: 'SMTP email service',
    },
    dingtalk: {
      name: 'DingTalk',
      description: 'DingTalk robot webhook',
    },
    feishu: {
      name: 'Feishu',
      description: 'Feishu robot webhook',
    },
    wechat_work: {
      name: 'WeCom',
      description: 'WeCom robot webhook',
    },
    slack: {
      name: 'Slack',
      description: 'Slack webhook',
    },
    telegram: {
      name: 'Telegram',
      description: 'Telegram bot',
    },
    discord: {
      name: 'Discord',
      description: 'Discord webhook',
    },
    aliyun_sms: {
      name: 'Alibaba Cloud SMS',
      description: 'Alibaba Cloud SMS service',
    },
    tencent_sms: {
      name: 'Tencent Cloud SMS',
      description: 'Tencent Cloud SMS service',
    },
    webhook: {
      name: 'Webhook',
      description: 'Generic webhook push',
    },
    // Web Search Providers
    google_search: {
      name: 'Google Custom Search',
      description: 'Google Programmable Search Engine',
    },
    bing_search: {
      name: 'Bing Web Search',
      description: 'Microsoft Bing Web Search API',
    },
    searxng: {
      name: 'SearXNG',
      description: 'SearXNG open-source meta-search engine',
    },
  },
};
